import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-wa-input',
	templateUrl:'./WaInputPage.html',
	styles: [],
	styleUrls:['./WaInputPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class WaInputPage
{
	mdContent_367 = `\`\`\`java
import com.jwebmp.webawesome.components.input.WaInput;
\`\`\``;
	mdContent_368 = `\`\`\`java
new WaInput<>()
\`\`\``;
	mdContent_369 = `\`\`\`java
var input = new WaInput<>();
input.setLabel("Name");
input.setPlaceholder("Enter your name");
\`\`\``;
	mdContent_370 = `\`\`\`java
var input = new WaInput<>();
input.setType("password");
input.setLabel("Password");
input.setPasswordToggle(true);
\`\`\``;
	mdContent_371 = `\`\`\`java
var input = new WaInput<>();
input.setType("search");
input.setPlaceholder("Search...");
input.setClearable(true);
var icon = new WaIcon<>("magnifying-glass");
icon.addAttribute("slot", "start");
input.add(icon);
\`\`\``;
}
